import { render } from "./BankTransferUSD.vue?vue&type=template&id=eb1511b2&scoped=true"
import script from "./BankTransferUSD.vue?vue&type=script&lang=js"
export * from "./BankTransferUSD.vue?vue&type=script&lang=js"

import "./BankTransferUSD.vue?vue&type=style&index=0&id=eb1511b2&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb1511b2"]])

export default __exports__